import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  tabsItem: {
    marginBottom: "10px",
    width: "70%",
  },
  header: {
    marginBottom: "20px",
  },
  tasksContainer: {
    marginTop: "30px",
  },
  sectionTitle: {
    fontSize: theme.typography.pxToRem(30),
    fontFamily: "Inter",
    fontWeight: 600,
  },
  noTasksMessage: {
    fontSize: theme.typography.pxToRem(16),
    fontFamily: "Lato",
    fontWeight: 400,
    [theme.breakpoints.down("sm")]: {
      margin: "auto",
      fontSize: theme.typography.pxToRem(18),
    },
  },
  takeAssessmentButton: {
    padding: "10px 30px",
    borderRadius: "100px",
    color: "black",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    fontFamily: "Inter",
    marginRight: "20px",
    "&:hover": {
      backgroundColor: "#E6F1FF",
      color: "black",
    },
  },
  takeAssessmentIcon: {
    width: "16px",
    height: "18px",
  },
  mobileTakeAssessmentIcon: {
    "&:hover": {
      backgroundColor: "#E6F1FF",
    },
  },
  createTaskButton: {
    padding: "8px 24px 8px 24px",
    color: "white",
    backgroundColor: "#0344DC",
    borderRadius: "100px",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    "&:hover": {
      backgroundColor: "#022984",
      color: "white",
    },
  },
  createTaskIcon: {
    color: "#22D9BB",
  },
  loader: {
    margin: "auto",
  },
  loadMoreButton: {
    width: "130px",
    height: "43px",
    backgroundColor: "#F1F5FF",
    padding: "12px 24px",
    color: "#0344DC",
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 600,
    fontFamily: "Inter",
    margin: "auto",
    marginTop: "20px",
    borderRadius: "100px",
    "&:hover": {
      backgroundColor: "#0344DC",
      color: "#F1F5FF",
    },
  },
}));
